import { Pipe, PipeTransform } from "@angular/core";
import * as moment from "moment";
import { TranslateService } from "@ngx-translate/core";

interface DateStrings {
  year: string;
  years: string;
  month: string;
  months: string;
  day: string;
  days: string;
}

@Pipe({
  name: "age",
  pure: false,
})
export class AgePipe implements PipeTransform {
  private date: Date;
  private dateStrings: null | DateStrings;

  constructor(private translateService: TranslateService) {
    translateService
      .stream("DATE")
      .subscribe((strings) => (this.dateStrings = strings));
  }

  transform(value: string): string {
    const today = moment();
    const birthdate = moment(value);
    const years = today.diff(birthdate, "years");
    let html = "";
    if (years > 1) {
      html = years + " " + this.dateStrings.years;
    } else if (years === 1) {
      html = years + " " + this.dateStrings.year;
    }

    const months = today.subtract(years, "years").diff(birthdate, "months");
    if (months > 1) {
      html += " " + months + " " + this.dateStrings.month;
    } else if (months === 1) {
      html += " " + months + " " + this.dateStrings.months;
    }
    if (html.length === 0) {
      html = " < 1 " + this.dateStrings.month;
    }
    return html;
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/core/pipes/age.pipe.ts